/** Reserve the tab synchronously, before imports/fetches can consume the browser's user activation. */
export async function openPdfInNewTab (generate: () => Promise<Blob>): Promise<void> {
    const tab = window.open("about:blank", "_blank")
    if (!tab) {
        throw new Error("Браузер заблокировал вкладку. Разрешите всплывающие окна для сайта и нажмите «Скачать» снова.")
    }
    let url: string | undefined
    try {
        tab.opener = null
        tab.document.title = "Формируем сертификат…"
        tab.document.body.textContent = "Формируем сертификат…"
        tab.document.body.style.cssText = "font: 18px sans-serif; padding: 24px; color: #234642"
        const blob = await generate()
        if (tab.closed) return
        url = URL.createObjectURL(blob)
        tab.location.replace(url)

        // Keep the PDF available after leaving the profile, until its own tab is closed.
        const pdfUrl = url
        const timer = window.setInterval(() => {
            if (tab.closed) {
                URL.revokeObjectURL(pdfUrl)
                window.clearInterval(timer)
            }
        }, 1000)
    } catch (error) {
        if (url) URL.revokeObjectURL(url)
        if (!tab.closed) tab.close()
        throw error
    }
}
